var productionMode = false;
const urlStart = "https://sahmoil-dash.ahm.to";
const urlSSO = "https://sahmoil-sso.ahm.to/";
const VUE_APP_GOOGLE_MAPS_API_ID_DOMAIN_DETECTION = "48d5b2e803a56930f03e701b";
const VUE_APP_GOOGLE_MAPS_API_KEY_DOMAIN_DETECTION = "AIzaSyA2Da8D5RWn1KEomfiG0RWx51o1zJO_4L0";

export default { productionMode, urlStart, urlSSO, VUE_APP_GOOGLE_MAPS_API_ID_DOMAIN_DETECTION, VUE_APP_GOOGLE_MAPS_API_KEY_DOMAIN_DETECTION };
